import Immutable from 'immutable';
import {
  FLAG_GETTING_CREDIT_NOTES,
  GET_CREDIT_NOTES,
  CLEAR_CREDIT_NOTES,
  GET_CREDIT_NOTE,
  CLEAR_CREDIT_NOTE,
  FLAG_CREDIT_NOTE_ACTIVITY,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CREDIT_NOTES:
      return state.setIn(['all', 'loading'], payload);
    case GET_CREDIT_NOTES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CREDIT_NOTES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_CREDIT_NOTE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CREDIT_NOTE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_CREDIT_NOTE_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
